// Generated types for MBSE_Port
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from '../../sysml/types/sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from '../../sysml/types/sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MBSE_PortReadAPI extends SysMLElementReadAPI {
  direction: "input" | "output";
  flow_type: "material" | "energy" | "signal";
  flow_subtype: "Solid" | "Liquid" | "Gas" | "Mechanical" | "Flow" | "Chemical" | "Thermal" | "Biological" | "Electrical" | "Magnetic" | "Radiant" | "Nuclear" | "Command" | "Feedback" | "Measurement" | "Status" | "Synchronization";
  source?: string | null;
  group?: string | null;
}

export interface MBSE_PortWriteAPI extends SysMLElementWriteAPI {
  direction: "input" | "output";
  flow_type: "material" | "energy" | "signal";
  flow_subtype: "Solid" | "Liquid" | "Gas" | "Mechanical" | "Flow" | "Chemical" | "Thermal" | "Biological" | "Electrical" | "Magnetic" | "Radiant" | "Nuclear" | "Command" | "Feedback" | "Measurement" | "Status" | "Synchronization";
  source?: string | null;
  group?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MBSE_PortReadAPISchema: z.ZodType<MBSE_PortReadAPI> = SysMLElementReadAPISchemaObject.extend({
  direction: z.enum(["input", "output"]),
  flow_type: z.enum(["material", "energy", "signal"]),
  flow_subtype: z.enum(["Solid", "Liquid", "Gas", "Mechanical", "Flow", "Chemical", "Thermal", "Biological", "Electrical", "Magnetic", "Radiant", "Nuclear", "Command", "Feedback", "Measurement", "Status", "Synchronization"]),
  source: z.string().nullable().optional(),
  group: z.string().nullable().optional(),
}).passthrough();

export const MBSE_PortWriteAPISchema: z.ZodType<MBSE_PortWriteAPI> = SysMLElementWriteAPISchemaObject.extend({
  direction: z.enum(["input", "output"]),
  flow_type: z.enum(["material", "energy", "signal"]),
  flow_subtype: z.enum(["Solid", "Liquid", "Gas", "Mechanical", "Flow", "Chemical", "Thermal", "Biological", "Electrical", "Magnetic", "Radiant", "Nuclear", "Command", "Feedback", "Measurement", "Status", "Synchronization"]),
  source: z.string().nullable().optional(),
  group: z.string().nullable().optional(),
}).passthrough();
